
(function($){

  var context = {

    init: function(){
      $(".query-string-update").click(function(e){
        e.preventDefault();
        data = $(this).data();
        data.currentUrl = btoa(window.location.href);
        $.ajax({
          url: "/ajax/update_query",
          data: data,
          success: function(data){
            window.location = atob(data.url);
          }
        });
      });
    }

  }

  context.init();

})(jQuery);
